/*******************************************************************************
 * Project：
 * Summary:
 *　　 Action user
 * Remarks:
 *    Define action for users
 * History：
 *      CuongLD            2021/05/31    Create
 ******************************************************************************/

import { Action } from '@ngrx/store';
import { ILoading } from '../../models/loading.interface';

export enum ELoadingActions {
    GetLoading = '[User] Get GetLoading'
}

export class GetLoading implements Action {
    public readonly type = ELoadingActions.GetLoading;
    constructor(public payload: ILoading) { }
}

export type LoadingActions = GetLoading;
